(function ($) {
    const resetOutputWrapper = outputWrapper => {
        outputWrapper.classList.remove('success');
        outputWrapper.classList.remove('error');
        outputWrapper.classList.remove('error');
        outputWrapper.textContent = '';
    };

    const showOutputWrapper = (outputWrapper, settings) => {
        const { title, error, success } = settings;

        if (error) {
            outputWrapper.classList.add('error');
        } else if (success) {
            outputWrapper.classList.add('success');
        } else {
            outputWrapper.classList.add('error');
        }

        outputWrapper.textContent = title;
    };

    $('.js-cf-form').on('keydown', e => {
        if (e.key === 'Enter') {
            const activeElement = document.activeElement;
            if (activeElement.getAttribute('type') === 'checkbox') {
                e.preventDefault();
                if (!activeElement.checked) {
                    activeElement.checked = true;
                } else {
                    activeElement.checked = false;
                }
            }
        }
    });

    $('.js-cf-form').on('submit', function (e) {
        e.preventDefault();

        const formLoader = this.querySelector('.loader');

        if (formLoader) formLoader.classList.add('-active');

        const $form = $(this);
        let data = $form.serialize();
        const alertWrapper = $form[0].querySelector('.form-alert');
        const formOutputWrapper = $form.find('.form__output-wrapper');

        if (formOutputWrapper && formOutputWrapper.length > 0) {
            resetOutputWrapper(formOutputWrapper[0]);
        }

        $form.addClass('is-loading');

        const recaptchaKey = $form.find('#g-recaptcha').val();
        const formId = $form.attr('id');
        let formObject = document.getElementById(formId);
        const formData = new FormData(formObject);

        const filesToUpload = $form.find('[type="file"]');

        grecaptcha.ready(function () {
            grecaptcha
                .execute(recaptchaKey, { action: 'submit' })
                .then(function (token) {
                    formData.append('g_recaptcha_token', token);
                    formData.append('referer_site', window.location.href);

                    $.ajax({
                        type: 'post',
                        url: ajax.url,
                        data: formData,
                        processData: false,
                        contentType: false,
                        beforeSend: function () {
                            $('.js-cf-error').remove();
                            $('.form-field').removeClass('error');
                            $form
                                .find('.js-form-output')
                                .removeClass(
                                    'has-errors is-warning is-success'
                                );

                            $('.js-cf-form__status').removeClass('success');
                            $('.js-cf-form__status').hide();
                            $('.js-cf-form__status span').html('');
                        },
                        success: function (response) {
                            response = $.parseJSON(response);

                            let alert_data = {};

                            if (response.status == 'ERROR') {
                                $.each(
                                    response.errors.fields,
                                    function (key, value) {
                                        const $parent = $form
                                            .find(`[name="${key}"]`)
                                            .parents('.form-field');
                                        $parent.addClass('error');
                                        const fieldTextOutput =
                                            $parent && $parent.length > 0
                                                ? $parent[0].querySelector(
                                                      '.js-text-wrapper'
                                                  )
                                                : null;

                                        if (fieldTextOutput)
                                            fieldTextOutput.textContent = value;
                                    }
                                );

                                alert_data = {
                                    type: 'alert:show',
                                    title: response.errors.form,
                                    error: true,
                                };
                            } else if (response.status == 'WARNING') {
                                $form
                                    .find(
                                        ':input:not([type=hidden]):not(:checkbox)'
                                    )
                                    .val('');
                                $form.find('textarea').val('');
                                $form
                                    .find('input[type="checkbox"]')
                                    .prop('checked', false);

                                $form
                                    .find('textarea')
                                    .removeClass('has-content');

                                const selects =
                                    $form[0].querySelectorAll('select');

                                selects.forEach(select => {
                                    select.dispatchEvent(new Event('change'));
                                });

                                $('.js-text-wrapper').text('');

                                alert_data = {
                                    type: 'alert:show',
                                    title: response.errors.send_mail
                                        ? response.errors.send_mail
                                        : response.save_form,
                                };
                            } else if (response?.errors?.send_mail) {
                                alert_data = {
                                    type: 'alert:show',
                                    title: response.errors.send_mail,
                                };
                            } else {
                                $form
  .find(':input:not([type=hidden]):not(:checkbox)')
  .each(function () {
    $(this).val('');
    this.dispatchEvent(new Event('input', { bubbles: true }));
    this.dispatchEvent(new Event('change', { bubbles: true }));
  });

                                $form.find('textarea').val('');
                                $form
                                    .find('textarea')
                                    .removeClass('has-content');

                                const selects =
                                    $form[0].querySelectorAll('select');

                                selects.forEach(select => {
                                    select.dispatchEvent(new Event('change'));
                                });

                                $('.js-text-wrapper').text('');

                                $form
                                    .find('input[type="checkbox"]')
                                    .prop('checked', false);

                                alert_data = {
                                    type: 'alert:show',
                                    title: response.send_mail,
                                    success: true,
                                };

                                $('.js-cf-form__status').addClass('success');
                                $('.js-cf-form__status').show();
                                $('.js-cf-form__status span').html(
                                    response.status_msg
                                );
                            }
                            if (
                                formOutputWrapper &&
                                formOutputWrapper.length > 0
                            ) {
                                showOutputWrapper(
                                    formOutputWrapper[0],
                                    alert_data
                                );
                            }
                            $form.removeClass('is-loading');
                            if (formLoader)
                                formLoader.classList.remove('-active');
                        },
                    });
                });
        });
    });
})(jQuery);
